import { render, staticRenderFns } from "./SystemRequirement.vue?vue&type=template&id=da193778&scoped=true&"
import script from "./SystemRequirement.vue?vue&type=script&lang=ts&"
export * from "./SystemRequirement.vue?vue&type=script&lang=ts&"
import style0 from "./SystemRequirement.vue?vue&type=style&index=0&id=da193778&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da193778",
  null
  
)

export default component.exports